import Fuse from 'fuse.js';

import IfIcon from '@/components/atoms/Icons/IfIcon';
import { type Desks } from '@/hooks/useDesks';
import { type Rule } from '@/shared/types/rules';

import { type EntityResult } from '../../types';
import { MAX_PER_TYPE } from '../../utils';

/**
 * Searches rules using a pre-built Fuse instance.
 * Shows environment name as subtitle pill (like integrations).
 */
export const searchRules = (
  query: string,
  fuse: Fuse<Rule> | null,
  desksData: Desks | undefined
): EntityResult[] => {
  if (!fuse || !desksData?.desks) {
    return [];
  }

  // Create desk lookup map for O(1) access
  const deskMap = new Map(desksData.desks.map((d) => [d.desk_id, d]));

  return fuse.search(query, { limit: MAX_PER_TYPE }).map(({ item: rule, score }) => {
    const desk = deskMap.get(rule.desk_id);
    return {
      id: rule.rule_id,
      name: rule.name,
      type: 'rule' as const,
      path: `/environments/${rule.desk_id}/rules/${rule.rule_id}`,
      icon: IfIcon,
      subtitle: desk?.name, // Environment name pill
      score: 1 - (score ?? 0),
    };
  });
};
